import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.marine,
  tileBgColor: colors.white,
  iconBgColor: colors.marine
};
export default imageGallery;